import { Form, Input, Button, Select } from 'antd';
import React from 'react';
import { ResultStyle } from './result.style';
import { SubjectModel } from 'data/subject/subject.model';
import { useUser } from '../../users/hooks/useUser';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useResult } from '../hooks/useResult';
import { useGrade } from 'features/routine/hooks/useGrade';
import { useExamRoutine } from 'features/examRoutine/hooks/useExamRoutine';
import { useSubject } from '../hooks/useSubject';
import { GradeModel } from 'data/grade/grade.model';
import { KButton } from 'common/component/KButton';

interface studentMarks {
  studentId: string;
  obtained_mark: string;
}

export const ResultPublishForm = (props: any) => {
  const { onVisibleChange, onSetReloadResult, examType, examYear, grade } = props;
  const [form] = Form.useForm();
  const { Option } = Select;

  const { fetchGradeSubjects } = useGrade();
  const { fetchGradeStudent } = useUser();
  const { publishResult } = useResult();

  const studentGrade = useSelector((state: RootState) => state.student);
  const gradeSubject = useSelector((state: RootState) => state.gradeSubjects);

  const [marksState, setMarksState] = React.useState<studentMarks[]>([]);
  const [isAddMarksClicked, setIsAddMarksClicked] = React.useState(false);
  const [selectedGrade, setSelectedGrade] = React.useState<string>('');
  const [selectedSection, setSelectedSection] = React.useState<string>('');
  const [gradeData, setGradeData] = React.useState<GradeModel>({
    id: '',
    startTime: '',
    endTime: '',
    sections: [],
  });

  const handlemarks = () => {
    if (selectedGrade !== '' && selectedSection !== '') {
      fetchGradeStudent(selectedGrade, selectedSection);
      setIsAddMarksClicked(true);
    }
  };

  const handleMarkChanged = (obtained_mark: string, studentId: string) => {
    console.log('obtained_mark ' + obtained_mark);
    const index = marksState.findIndex((e) => e.studentId === studentId);
    let values = [...marksState];
    if (index === -1) {
      values.push({ studentId: studentId, obtained_mark: obtained_mark });
    } else {
      values[index] = { studentId: studentId, obtained_mark: obtained_mark };
    }
    setMarksState(values);
  };

  return (
    <ResultStyle>
      <Form form={form} size="large" layout="vertical">
        <div className="gradeExamYearType">
          <Form.Item label="Exam Year" name="examYearId">
            <Select defaultValue="Select Exam Year" style={{ width: 300 }}>
              {examYear.map((item: any) => (
                <Option value={item.id}>{item.id}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Exam Type" name="examTypeId">
            <Select defaultValue="Select Exam Type" style={{ width: 300 }}>
              {examType.map((item: any) => (
                <Option value={item.id}>{item.id}</Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="gradeExamYearType">
          <Form.Item label="Grade" name="gradeId">
            <Select
              style={{ width: 300 }}
              defaultValue="Select Grade"
              className="grade-select-field"
              onSelect={(value) => {
                setSelectedGrade(value);

                grade.map((item: any) => {
                  if (item.id === value) {
                    setGradeData(item);
                    // fetchGradeSubjects(item);
                  }
                });
              }}
            >
              {grade.map((item: any) => (
                <Select.Option key={`atten-class${item.id}`} value={item.id}>
                  {item.id}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Section" name="sectionId">
            <Select
              style={{ width: 300 }}
              defaultValue="Select Section"
              className="grade-select-field"
              onSelect={(val) => {
                setSelectedSection(val);
              }}
            >
              {gradeData.sections.map((section) => (
                <Select.Option key={`atten-class${section.id}`} value={section.id}>
                  {section.id}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <Form.Item name="subjectCode" label="Subject">
          <Select defaultValue=" Select Subject">
            {gradeSubject.data.subjects.map((item) => (
              <Option value={item.code}>{item.title}</Option>
            ))}
          </Select>
        </Form.Item>
        <KButton onClick={handlemarks}>Add Marks</KButton>
        {isAddMarksClicked && (
          <div className="markList">
            <div className="studentMarks">
              <div className="students">Students</div>
              <div className="marks">Obtained Marks</div>
            </div>

            {studentGrade.data.map((student) => (
              <div className="studentMarks">
                <div className="studentName">
                  <label>{student.__user__.full_name}</label>
                </div>
                <div className="studentObtainedMarks">
                  <input onChange={(e) => handleMarkChanged(e.target.value, student.id)} />
                </div>
              </div>
            ))}
          </div>
        )}

        <Form.Item>
          <Button
            onClick={() => {
              publishResult(
                {
                  ...form.getFieldsValue(),
                  marksEntries: marksState,
                  gradeId: selectedGrade,
                },
                form,
                onVisibleChange,
                onSetReloadResult,
                setIsAddMarksClicked,
                setMarksState,
                setSelectedGrade,
                setSelectedSection,
              );
              // .then(() => {
              //   setIsAddMarksClicked(false);
              //   setMarksState([]);
              // });
            }}
          >
            SAVE
          </Button>
        </Form.Item>
      </Form>
    </ResultStyle>
  );
};
